// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
}

/* Base Button */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  width: 200px;
  justify-content: center;
  height: 44px;
}

/* Save Button */
.save-btn {
  background: linear-gradient(135deg, #28a745, #218838);
  color: white;
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(40, 167, 69, 0.3);
}

.save-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Discard Button */
.discard-btn {
  background: white;
  color: #dc3545;
  border: 2px solid #dc3545;
}

.discard-btn:hover {
  background: #dc3545;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(220, 53, 69, 0.3);
}

/* Icon */
.icon {
  font-size: 14px;
}

/* Loader Spinner */
.loader {
  width: 14px;
  height: 14px;
  border: 2px solid white;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/action-buttons/action-buttons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".action-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-bottom: 20px;\n}\n\n/* Base Button */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n  width: 200px;\n  justify-content: center;\n  height: 44px;\n}\n\n/* Save Button */\n.save-btn {\n  background: linear-gradient(135deg, #28a745, #218838);\n  color: white;\n}\n\n.save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(40, 167, 69, 0.3);\n}\n\n.save-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Discard Button */\n.discard-btn {\n  background: white;\n  color: #dc3545;\n  border: 2px solid #dc3545;\n}\n\n.discard-btn:hover {\n  background: #dc3545;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(220, 53, 69, 0.3);\n}\n\n/* Icon */\n.icon {\n  font-size: 14px;\n}\n\n/* Loader Spinner */\n.loader {\n  width: 14px;\n  height: 14px;\n  border: 2px solid white;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
